import { render, staticRenderFns } from "./MinArea.vue?vue&type=template&id=4c53a858&scoped=true"
import script from "./MinArea.vue?vue&type=script&lang=js"
export * from "./MinArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c53a858",
  null
  
)

export default component.exports